import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import {
  NavigationEnd,
  NavigationStart,
  Router,
  Event as RouterEvent,
} from '@angular/router';
import { SpinnerService } from './core/core.index';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone:false
})
export class AppComponent implements OnInit {
  title = 'template';
  public page = '';

  constructor(private router: Router,
              private spinner: SpinnerService,
              private renderer: Renderer2,
              @Inject(DOCUMENT) private document: Document) {
    this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationStart) {
        const URL = event.url.split('/');
        this.page = URL[2];
        this.spinner.show();
      }
      if (event instanceof NavigationEnd) {
        this.spinner.hide();
      }
    });

    this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationStart) {
        this.spinner.show();
      }
      if (event instanceof NavigationEnd) {
        this.spinner.hide();
      }
    });
  }

  ngOnInit(): void {
    this.injectGoogleMapsScript()
  }

  injectGoogleMapsScript(): void {
    const script = this.renderer.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.mapKey}&loading=async&v=weekly`;
    script.defer = true;
    script.async = true;
    this.renderer.appendChild(this.document.body, script);
  }
}
